











import { Component, Prop, Vue } from 'vue-property-decorator';
import Player from '@vimeo/player';

@Component<VimeoContainer>({})
export default class VimeoContainer extends Vue {
  // PROPS
  @Prop({ type: String, required: false, default: '' })
  videoClass!: string;
  @Prop({ type: String, required: true })
  id!: string;
  @Prop({ type: String, required: true })
  url!: string;

  // FIELDS
  hasVimeoError = false;

  // METHODS
  async bootVimeo(id: string, url: string) {
    await new Player(id, {
      url,
      responsive: true,
    }).ready();
  }
  getElmInfo() {
    const getElm = (ref: any) => (Array.isArray(ref) ? ref[0] : ref) as Element;
    return this.hasVimeoError ? getElm(this.$refs.error) : getElm(this.$refs.vimeoIframe);
  }

  // LIFECYCLE HOOKS
  mounted() {
    this.bootVimeo(this.id, this.url)
      .catch((e) => {
        console.error(e);
        this.hasVimeoError = true;
      })
      .finally(() => this.$emit('load', this.getElmInfo()));
  }
}
